import { Skeleton } from '@openedx/paragon';

export const CartSummarySkeleton = () => (
  <section
    aria-label="cart-summary"
    className="col-md-5 pr-md-5 col-cart-summary"
  >
    <div>
      {/* Cart Summary Heading */}
      <Skeleton width="50%" className="mb-3" />
      <Skeleton className="mb-4 mr-4" />

      {/* Cart Items */}
      <div className="row align-items-center mb-5">
        <div className="col-5">
          <div className="react-loading-skeleton embed-responsive embed-responsive-16by9" />
        </div>
        <div className="col-7">
          <Skeleton width="50%" className="mb-3" />
          <Skeleton className="mr-4" />
        </div>
      </div>

      {/* Order Summary */}
      <Skeleton width="50%" className="mb-3" />
      <Skeleton className="mb-2" />
      <Skeleton className="mb-5" />

      {/* Order Details */}
      <Skeleton width="50%" className="mb-3" />
      <Skeleton className="mb-2 mr-4" />
      <Skeleton width="75%" className="mb-5" />
    </div>
  </section>
);
